export const SET_COUPON_MODAL_IS_VISIBLE = 'SET_COUPON_MODAL_IS_VISIBLE';
export const COUPON_POST_SUCCESS = 'COUPON_POST_SUCCESS';
export const SET_IS_REQUESTING = 'SET_IS_REQUESTING';